export const getCustomer = async (phone_number: string, url: string) => {
  return fetch(
    `${url}/erpnext?doctype=Customer&fields=["name", "custom_email"]&filters=[["Customer","phone_number","=","${phone_number}"]]`
  )
    .then((res) => res.json())
    .then((res) => res)
}

export const getCustomerAddress = async (name: string, url: string) => {
  return fetch(
    `${url}/erpnext?doctype=Address&fields=["address_line1", "address_line2", "city", "country", "address_type", "disabled", "pincode"]&filters=[["Dynamic Link", "link_doctype", "=", "Customer"],
			["Dynamic Link", "link_name", "=", "${name}"],
			["Dynamic Link", "parenttype", "=", "Address"]]`
  )
    .then((res) => res.json())
    .then((res) => res)
}
